import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

/**
 * Botón de acción principal de la aplicación.
 *
 * Es el mismo estilo que ya usaban las pantallas de listado ("Nuevo producto",
 * "Nueva factura", "Nuevo cliente"), que tenían este bloque copiado cinco veces
 * bajo el nombre GradientButton. Los formularios, en cambio, definían su propio
 * actionButtonStyle con esquinas de 50px, así que en una misma pantalla convivían
 * botones con formas distintas: en Configuración, "Guardar cambios" salía como
 * píldora y "Eliminar información" como rectángulo.
 *
 * Vive acá para que haya un solo lugar donde cambiarlo.
 */
export const ActionButton = styled(Button)(() => ({
  borderRadius: '7px',
  color: '#1C1525',
  fontWeight: 700,
  minHeight: '36px',
  padding: '7px 14px',
  textTransform: 'none',
  backgroundColor: '#F5A623',
  boxShadow: 'none',
  transition: 'background-color 0.16s ease, box-shadow 0.16s ease',
  border: '1px solid rgba(255, 255, 255, 0.06)',
  fontSize: '13px',
  lineHeight: 1,
  letterSpacing: '0.01em',
  '& .MuiButton-startIcon': {
    marginRight: '6px',
    '& svg': { fontSize: '18px' },
  },
  '&:hover': {
    backgroundColor: '#E99A18',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
  },
  '&:active': {
    backgroundColor: '#D9890D',
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    backgroundColor: '#6F6A72',
    color: 'rgba(255, 255, 255, 0.6)',
  }
}));

/**
 * Variante secundaria: misma forma y medidas, sin relleno. Para "Cancelar",
 * "Limpiar" y demás acciones que acompañan a la principal sin competir con ella.
 */
export const SecondaryButton = styled(Button)(() => ({
  borderRadius: '7px',
  color: '#F5A623',
  fontWeight: 600,
  minHeight: '36px',
  padding: '7px 14px',
  textTransform: 'none',
  backgroundColor: 'transparent',
  boxShadow: 'none',
  transition: 'background-color 0.16s ease, border-color 0.16s ease',
  border: '1px solid rgba(245, 166, 35, 0.5)',
  fontSize: '13px',
  lineHeight: 1,
  letterSpacing: '0.01em',
  '& .MuiButton-startIcon': {
    marginRight: '6px',
    '& svg': { fontSize: '18px' },
  },
  '&:hover': {
    backgroundColor: 'rgba(245, 166, 35, 0.08)',
    borderColor: '#F5A623',
  },
  '&.Mui-disabled': {
    color: 'rgba(255, 255, 255, 0.4)',
    borderColor: 'rgba(255, 255, 255, 0.15)',
  }
}));

export default ActionButton;
